import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getGraphList } from '../../../../slices/thunks';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import DeleteGraphModal from './Delete/DeleteGraph';
import AddEditGraphModal from './Add_Edit/AddEditGraphModal';

const GraphList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorGraph = createSelector(
		state => state.Screen,
		graph => ({
			graphList: graph.graphList,
			isLoadingList: graph.isLoadingList,
			isGraphSuccess: graph.isGraphSuccess,
			error: graph.error,
			isAdding: graph.isAdding,
			isAdded: graph.isAdded,
			isAddError: graph.isAddError,
			isUpdating: graph.isUpdating,
			isUpdated: graph.isUpdated,
			isUpdateError: graph.isUpdateError,
			isDeleting: graph.isDeleting,
			isDeleted: graph.isDeleted,
			isDeleteError: graph.isDeleteError,
		})
	);

	const { graphList, isLoadingList } = useSelector(
		selectorGraph
	);

	useEffect(() => {
		dispatch(getGraphList());
	}, []);

	const [dataGraph, setDataGraph] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Graph
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = graph => {
		setDataGraph(graph);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = graph => {
		setDataGraph(graph);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'graph',
				columnDefType: 'display',
				 size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const graphData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(graphData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const graphData =
														cellProps.row.original;
													handleClickDelete(graphData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Nombre', accessorKey: 'name',  size: 'auto' },
			{ header: 'Código', accessorKey: 'code',  size: 'auto' },
			{ header: 'Descripción', accessorKey: 'description',  size: 'auto' },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataGraph({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Gráfico
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={graphList || []}
								isLoadingData={isLoadingList}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataGraph({});
											handleToggleModal();
										},
										title: 'Crear Gráfico'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditGraphModal
				dataGraph={dataGraph}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteGraphModal
				dataGraph={dataGraph}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default GraphList;
